export const trainData = [
  { x: 0.005, y: 0.564, y_pred_uf: 0.424, y_pred_of: 0.564 },
  { x: 0.114, y: 0.576, y_pred_uf: 0.341, y_pred_of: 0.576 },
  { x: 0.218, y: 0.634, y_pred_uf: 0.261, y_pred_of: 0.634 },
  { x: 0.323, y: 0.569, y_pred_uf: 0.181, y_pred_of: 0.569 },
  { x: 0.448, y: -0.593, y_pred_uf: 0.087, y_pred_of: -0.593 },
  { x: 0.528, y: -0.414, y_pred_uf: 0.025, y_pred_of: -0.414 },
  { x: 0.63, y: -0.849, y_pred_uf: -0.053, y_pred_of: -0.849 },
  { x: 0.749, y: -0.106, y_pred_uf: -0.143, y_pred_of: -0.106 },
  { x: 0.839, y: -0.191, y_pred_uf: -0.212, y_pred_of: -0.191 },
  { x: 1.05, y: 0.35, y_pred_uf: -0.373, y_pred_of: 0.35 },
];
export const testData = [
  { x: 0.028, y: 0.24 },
  { x: 0.161, y: 0.27 },
  { x: 0.25, y: 1.098 },
  { x: 0.367, y: -0.032 },
  { x: 0.441, y: -0.273 },
  { x: 0.503, y: -1.252 },
  { x: 0.603, y: -0.546 },
  { x: 0.759, y: -0.98 },
  { x: 0.844, y: 0.227 },
  { x: 0.957, y: 1.154 },
];

export const ddTrainTest = [
  { x: 1, y_train: 14, y_test: 23 },
  { x: 3, y_train: 6, y_test: 17 },
  { x: 4, y_train: 4, y_test: 15.5 },
  { x: 5, y_train: 3, y_test: 15 },
  { x: 6, y_train: 2.5, y_test: 15 },
  { x: 7, y_train: 2, y_test: 16 },
  { x: 8, y_train: 1.8, y_test: 18.5 },
  { x: 9, y_train: 1.8, y_test: 24 },
  { x: 11, y_train: 1.6, y_test: 6 },
  { x: 13, y_train: 1.4, y_test: 3 },
  { x: 15, y_train: 1.1, y_test: 2 },
  { x: 17, y_train: 1.1, y_test: 1.82 },
  { x: 19, y_train: 1.1, y_test: 1.82 },
];

export const ddUShape = [
  { x: 1, y_u: 23 },
  { x: 3, y_u: 17 },
  { x: 4, y_u: 15.5 },
  { x: 5, y_u: 15 },
  { x: 6, y_u: 15 },
  { x: 7, y_u: 16 },
  { x: 8, y_u: 18.5 },
  { x: 9, y_u: 25.5 },
  { x: 10, y_u: 35 },
];

export const errorData = [
  {
    x: 0.028,
    error_uf: 0.108,
    error_of: 7.631,
    error_good: 0.171,
    bias_uf: 0.013,
    bias_of: 0.315,
    bias_good: 0.019,
    var_uf: 0.022,
    var_of: 7.318,
    var_good: 0.107,
    noise_uf: 0.057,
    noise_of: 0.057,
    noise_good: 0.057,
    noise_final: 0.03,
    error_final: 1.09,
    bias_final: 0.95,
    var_final: 0.11,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.161,
    error_uf: 0.242,
    error_of: 0.655,
    error_good: 0.085,
    bias_uf: 0.19,
    bias_of: 0.016,
    bias_good: 0.007,
    var_uf: 0.014,
    var_of: 0.593,
    var_good: 0.027,
    noise_uf: 0.049,
    noise_of: 0.049,
    noise_good: 0.049,
    noise_final: 0.03,
    error_final: 0.81,
    bias_final: 0.65,
    var_final: 0.13,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.25,
    error_uf: 0.239,
    error_of: 0.154,
    error_good: 0.081,
    bias_uf: 0.208,
    bias_of: 0.0,
    bias_good: 0.002,
    var_uf: 0.01,
    var_of: 0.092,
    var_good: 0.021,
    noise_uf: 0.061,
    noise_of: 0.061,
    noise_good: 0.061,
    noise_final: 0.03,
    error_final: 0.68,
    bias_final: 0.5,
    var_final: 0.15,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.367,
    error_uf: 0.064,
    error_of: 0.102,
    error_good: 0.075,
    bias_uf: 0.004,
    bias_of: 0.0,
    bias_good: 0.007,
    var_uf: 0.007,
    var_of: 0.046,
    var_good: 0.016,
    noise_uf: 0.056,
    noise_of: 0.056,
    noise_good: 0.056,
    noise_final: 0.03,
    error_final: 0.58,
    bias_final: 0.35,
    var_final: 0.2,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.441,
    error_uf: 0.167,
    error_of: 0.113,
    error_good: 0.084,
    bias_uf: 0.083,
    bias_of: 0.001,
    bias_good: 0.001,
    var_uf: 0.007,
    var_of: 0.052,
    var_good: 0.023,
    noise_uf: 0.061,
    noise_of: 0.061,
    noise_good: 0.061,
    noise_final: 0.03,
    error_final: 0.55,
    bias_final: 0.3,
    var_final: 0.24,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.503,
    error_uf: 0.391,
    error_of: 0.133,
    error_good: 0.106,
    bias_uf: 0.282,
    bias_of: 0.0,
    bias_good: 0.001,
    var_uf: 0.007,
    var_of: 0.057,
    var_good: 0.027,
    noise_uf: 0.076,
    noise_of: 0.076,
    noise_good: 0.076,
    noise_final: 0.03,
    error_final: 0.54,
    bias_final: 0.24,
    var_final: 0.28,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.603,
    error_uf: 0.562,
    error_of: 0.128,
    error_good: 0.092,
    bias_uf: 0.451,
    bias_of: 0.004,
    bias_good: 0.004,
    var_uf: 0.009,
    var_of: 0.065,
    var_good: 0.028,
    noise_uf: 0.054,
    noise_of: 0.054,
    noise_good: 0.054,
    noise_final: 0.03,
    error_final: 0.546,
    bias_final: 0.2,
    var_final: 0.34,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.759,
    error_uf: 0.137,
    error_of: 0.175,
    error_good: 0.107,
    bias_uf: 0.022,
    bias_of: 0.015,
    bias_good: 0.007,
    var_uf: 0.017,
    var_of: 0.103,
    var_good: 0.038,
    noise_uf: 0.069,
    noise_of: 0.069,
    noise_good: 0.069,
    noise_final: 0.03,
    error_final: 0.68,
    bias_final: 0.15,
    var_final: 0.5,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.844,
    error_uf: 0.177,
    error_of: 0.262,
    error_good: 0.092,
    bias_uf: 0.108,
    bias_of: 0.0,
    bias_good: 0.014,
    var_uf: 0.022,
    var_of: 0.221,
    var_good: 0.035,
    noise_uf: 0.04,
    noise_of: 0.04,
    noise_good: 0.04,
    noise_final: 0.03,
    error_final: 0.81,
    bias_final: 0.13,
    var_final: 0.65,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
  {
    x: 0.957,
    error_uf: 0.713,
    error_of: 6.517,
    error_good: 0.216,
    bias_uf: 0.609,
    bias_of: 0.213,
    bias_good: 0.012,
    var_uf: 0.032,
    var_of: 6.239,
    var_good: 0.155,
    noise_uf: 0.051,
    noise_of: 0.051,
    noise_good: 0.051,
    noise_final: 0.03,
    error_final: 1.09,
    bias_final: 0.11,
    var_final: 0.95,
    noise_point: 0.03,
    error_point: 0.55,
    bias_point: 0.29,
    var_point: 0.27,
    x_point: 0.48,
  },
];
export const modelsData = [
  {
    x: 0.013,
    "uf-preds-0": 0.418,
    "uf-preds-1": 0.614,
    "uf-preds-2": 0.28,
    "uf-preds-3": 0.435,
    "uf-preds-4": 0.303,
    "uf-preds-5": 0.183,
    "uf-preds-6": 0.248,
    "uf-preds-7": -0.007,
    "uf-preds-8": 0.168,
    "uf-preds-9": 0.109,
    "uf-preds-10": 0.273,
    "uf-preds-11": 0.296,
    "uf-preds-12": 0.414,
    "uf-preds-13": 0.059,
    "uf-preds-14": 0.571,
    "of-preds-0": 0.534,
    "of-preds-1": -4.423,
    "of-preds-2": -0.019,
    "of-preds-3": -2.004,
    "of-preds-4": -1.84,
    "of-preds-5": 10.122,
    "of-preds-6": -8.253,
    "of-preds-7": 0.826,
    "of-preds-8": -7.947,
    "of-preds-9": -0.013,
    "of-preds-10": -0.86,
    "of-preds-11": -0.565,
    "of-preds-12": -2.681,
    "of-preds-13": 0.323,
    "of-preds-14": -0.943,
    "good-preds-0": 0.523,
    "good-preds-1": 0.02,
    "good-preds-2": -0.127,
    "good-preds-3": -0.042,
    "good-preds-4": -0.116,
    "good-preds-5": -0.417,
    "good-preds-6": -1.14,
    "good-preds-7": 0.254,
    "good-preds-8": -1.017,
    "good-preds-9": 0.015,
    "good-preds-10": 0.133,
    "good-preds-11": 0.058,
    "good-preds-12": 0.614,
    "good-preds-13": 0.082,
    "good-preds-14": 0.07,
  },
  {
    x: 0.125,
    "uf-preds-0": 0.333,
    "uf-preds-1": 0.474,
    "uf-preds-2": 0.196,
    "uf-preds-3": 0.339,
    "uf-preds-4": 0.242,
    "uf-preds-5": 0.168,
    "uf-preds-6": 0.223,
    "uf-preds-7": -0.018,
    "uf-preds-8": 0.134,
    "uf-preds-9": 0.056,
    "uf-preds-10": 0.218,
    "uf-preds-11": 0.266,
    "uf-preds-12": 0.335,
    "uf-preds-13": 0.063,
    "uf-preds-14": 0.45,
    "of-preds-0": 0.582,
    "of-preds-1": 2.216,
    "of-preds-2": 0.653,
    "of-preds-3": 0.959,
    "of-preds-4": 0.518,
    "of-preds-5": -1.566,
    "of-preds-6": 0.825,
    "of-preds-7": -0.044,
    "of-preds-8": 0.755,
    "of-preds-9": 0.475,
    "of-preds-10": -0.56,
    "of-preds-11": 0.788,
    "of-preds-12": 0.782,
    "of-preds-13": 0.047,
    "of-preds-14": 2.575,
    "good-preds-0": 0.823,
    "good-preds-1": 0.904,
    "good-preds-2": 0.813,
    "good-preds-3": 0.61,
    "good-preds-4": 0.63,
    "good-preds-5": 0.727,
    "good-preds-6": 0.6,
    "good-preds-7": 0.534,
    "good-preds-8": 0.598,
    "good-preds-9": 0.63,
    "good-preds-10": 0.77,
    "good-preds-11": 0.751,
    "good-preds-12": 0.583,
    "good-preds-13": 0.169,
    "good-preds-14": 0.78,
  },
  {
    x: 0.201,
    "uf-preds-0": 0.275,
    "uf-preds-1": 0.379,
    "uf-preds-2": 0.139,
    "uf-preds-3": 0.274,
    "uf-preds-4": 0.201,
    "uf-preds-5": 0.157,
    "uf-preds-6": 0.205,
    "uf-preds-7": -0.026,
    "uf-preds-8": 0.111,
    "uf-preds-9": 0.02,
    "uf-preds-10": 0.181,
    "uf-preds-11": 0.246,
    "uf-preds-12": 0.281,
    "uf-preds-13": 0.067,
    "uf-preds-14": 0.367,
    "of-preds-0": 0.696,
    "of-preds-1": 0.805,
    "of-preds-2": 0.771,
    "of-preds-3": 0.603,
    "of-preds-4": 0.393,
    "of-preds-5": 0.377,
    "of-preds-6": 0.877,
    "of-preds-7": 0.808,
    "of-preds-8": 0.472,
    "of-preds-9": 0.358,
    "of-preds-10": 0.767,
    "of-preds-11": 0.389,
    "of-preds-12": 0.286,
    "of-preds-13": 0.06,
    "of-preds-14": 0.64,
    "good-preds-0": 0.678,
    "good-preds-1": 0.864,
    "good-preds-2": 0.847,
    "good-preds-3": 0.675,
    "good-preds-4": 0.666,
    "good-preds-5": 0.733,
    "good-preds-6": 0.814,
    "good-preds-7": 0.411,
    "good-preds-8": 0.78,
    "good-preds-9": 0.558,
    "good-preds-10": 0.76,
    "good-preds-11": 0.752,
    "good-preds-12": 0.467,
    "good-preds-13": 0.205,
    "good-preds-14": 0.823,
  },
  {
    x: 0.346,
    "uf-preds-0": 0.164,
    "uf-preds-1": 0.199,
    "uf-preds-2": 0.03,
    "uf-preds-3": 0.149,
    "uf-preds-4": 0.122,
    "uf-preds-5": 0.136,
    "uf-preds-6": 0.172,
    "uf-preds-7": -0.04,
    "uf-preds-8": 0.068,
    "uf-preds-9": -0.048,
    "uf-preds-10": 0.111,
    "uf-preds-11": 0.207,
    "uf-preds-12": 0.178,
    "uf-preds-13": 0.073,
    "uf-preds-14": 0.21,
    "of-preds-0": 0.314,
    "of-preds-1": 0.473,
    "of-preds-2": 0.321,
    "of-preds-3": 0.135,
    "of-preds-4": 0.409,
    "of-preds-5": 0.023,
    "of-preds-6": 0.144,
    "of-preds-7": -0.289,
    "of-preds-8": 0.201,
    "of-preds-9": 0.372,
    "of-preds-10": 0.276,
    "of-preds-11": 0.341,
    "of-preds-12": 0.184,
    "of-preds-13": 0.292,
    "of-preds-14": 0.7,
    "good-preds-0": 0.085,
    "good-preds-1": 0.184,
    "good-preds-2": 0.232,
    "good-preds-3": 0.308,
    "good-preds-4": 0.207,
    "good-preds-5": 0.055,
    "good-preds-6": 0.21,
    "good-preds-7": -0.148,
    "good-preds-8": 0.155,
    "good-preds-9": -0.061,
    "good-preds-10": 0.216,
    "good-preds-11": 0.266,
    "good-preds-12": 0.103,
    "good-preds-13": 0.154,
    "good-preds-14": 0.393,
  },
  {
    x: 0.42,
    "uf-preds-0": 0.107,
    "uf-preds-1": 0.106,
    "uf-preds-2": -0.025,
    "uf-preds-3": 0.086,
    "uf-preds-4": 0.082,
    "uf-preds-5": 0.126,
    "uf-preds-6": 0.156,
    "uf-preds-7": -0.047,
    "uf-preds-8": 0.046,
    "uf-preds-9": -0.083,
    "uf-preds-10": 0.075,
    "uf-preds-11": 0.187,
    "uf-preds-12": 0.125,
    "uf-preds-13": 0.076,
    "uf-preds-14": 0.129,
    "of-preds-0": -0.148,
    "of-preds-1": -0.011,
    "of-preds-2": -0.093,
    "of-preds-3": -0.603,
    "of-preds-4": -0.205,
    "of-preds-5": -0.197,
    "of-preds-6": -0.394,
    "of-preds-7": -0.656,
    "of-preds-8": -0.198,
    "of-preds-9": -0.267,
    "of-preds-10": -0.031,
    "of-preds-11": -0.132,
    "of-preds-12": 0.075,
    "of-preds-13": 0.002,
    "of-preds-14": 0.333,
    "good-preds-0": -0.22,
    "good-preds-1": -0.197,
    "good-preds-2": -0.183,
    "good-preds-3": 0.011,
    "good-preds-4": -0.106,
    "good-preds-5": -0.305,
    "good-preds-6": -0.218,
    "good-preds-7": -0.458,
    "good-preds-8": -0.286,
    "good-preds-9": -0.408,
    "good-preds-10": -0.151,
    "good-preds-11": -0.034,
    "good-preds-12": -0.116,
    "good-preds-13": 0.065,
    "good-preds-14": 0.081,
  },
  {
    x: 0.511,
    "uf-preds-0": 0.038,
    "uf-preds-1": -0.007,
    "uf-preds-2": -0.093,
    "uf-preds-3": 0.008,
    "uf-preds-4": 0.033,
    "uf-preds-5": 0.113,
    "uf-preds-6": 0.135,
    "uf-preds-7": -0.056,
    "uf-preds-8": 0.018,
    "uf-preds-9": -0.126,
    "uf-preds-10": 0.031,
    "uf-preds-11": 0.163,
    "uf-preds-12": 0.061,
    "uf-preds-13": 0.08,
    "uf-preds-14": 0.031,
    "of-preds-0": -0.653,
    "of-preds-1": -0.732,
    "of-preds-2": -0.557,
    "of-preds-3": -0.506,
    "of-preds-4": -0.727,
    "of-preds-5": -0.321,
    "of-preds-6": -0.481,
    "of-preds-7": -0.712,
    "of-preds-8": -0.573,
    "of-preds-9": -0.865,
    "of-preds-10": -0.437,
    "of-preds-11": -0.533,
    "of-preds-12": -0.318,
    "of-preds-13": -0.228,
    "of-preds-14": -0.371,
    "good-preds-0": -0.489,
    "good-preds-1": -0.521,
    "good-preds-2": -0.604,
    "good-preds-3": -0.336,
    "good-preds-4": -0.427,
    "good-preds-5": -0.552,
    "good-preds-6": -0.592,
    "good-preds-7": -0.747,
    "good-preds-8": -0.685,
    "good-preds-9": -0.711,
    "good-preds-10": -0.539,
    "good-preds-11": -0.309,
    "good-preds-12": -0.361,
    "good-preds-13": -0.08,
    "good-preds-14": -0.262,
  },
  {
    x: 0.619,
    "uf-preds-0": -0.044,
    "uf-preds-1": -0.142,
    "uf-preds-2": -0.174,
    "uf-preds-3": -0.084,
    "uf-preds-4": -0.026,
    "uf-preds-5": 0.097,
    "uf-preds-6": 0.111,
    "uf-preds-7": -0.067,
    "uf-preds-8": -0.014,
    "uf-preds-9": -0.176,
    "uf-preds-10": -0.022,
    "uf-preds-11": 0.134,
    "uf-preds-12": -0.015,
    "uf-preds-13": 0.084,
    "uf-preds-14": -0.086,
    "of-preds-0": -0.73,
    "of-preds-1": -0.749,
    "of-preds-2": -0.938,
    "of-preds-3": 0.402,
    "of-preds-4": -0.518,
    "of-preds-5": -0.68,
    "of-preds-6": 0.002,
    "of-preds-7": -0.795,
    "of-preds-8": -0.681,
    "of-preds-9": -0.799,
    "of-preds-10": -0.984,
    "of-preds-11": -0.272,
    "of-preds-12": -0.686,
    "of-preds-13": -0.159,
    "of-preds-14": -0.524,
    "good-preds-0": -0.591,
    "good-preds-1": -0.612,
    "good-preds-2": -0.83,
    "good-preds-3": -0.598,
    "good-preds-4": -0.607,
    "good-preds-5": -0.47,
    "good-preds-6": -0.659,
    "good-preds-7": -0.856,
    "good-preds-8": -0.784,
    "good-preds-9": -0.789,
    "good-preds-10": -0.775,
    "good-preds-11": -0.404,
    "good-preds-12": -0.54,
    "good-preds-13": -0.239,
    "good-preds-14": -0.519,
  },
  {
    x: 0.729,
    "uf-preds-0": -0.128,
    "uf-preds-1": -0.279,
    "uf-preds-2": -0.256,
    "uf-preds-3": -0.179,
    "uf-preds-4": -0.085,
    "uf-preds-5": 0.082,
    "uf-preds-6": 0.086,
    "uf-preds-7": -0.078,
    "uf-preds-8": -0.047,
    "uf-preds-9": -0.228,
    "uf-preds-10": -0.075,
    "uf-preds-11": 0.105,
    "uf-preds-12": -0.093,
    "uf-preds-13": 0.089,
    "uf-preds-14": -0.205,
    "of-preds-0": -0.241,
    "of-preds-1": -0.311,
    "of-preds-2": -0.797,
    "of-preds-3": -0.392,
    "of-preds-4": -0.525,
    "of-preds-5": 0.058,
    "of-preds-6": -0.442,
    "of-preds-7": -0.676,
    "of-preds-8": -0.775,
    "of-preds-9": -0.516,
    "of-preds-10": -0.603,
    "of-preds-11": -0.062,
    "of-preds-12": -0.495,
    "of-preds-13": -0.297,
    "of-preds-14": -0.56,
    "good-preds-0": -0.44,
    "good-preds-1": -0.409,
    "good-preds-2": -0.655,
    "good-preds-3": -0.576,
    "good-preds-4": -0.506,
    "good-preds-5": -0.037,
    "good-preds-6": -0.294,
    "good-preds-7": -0.611,
    "good-preds-8": -0.42,
    "good-preds-9": -0.508,
    "good-preds-10": -0.643,
    "good-preds-11": -0.194,
    "good-preds-12": -0.48,
    "good-preds-13": -0.268,
    "good-preds-14": -0.559,
  },
  {
    x: 0.801,
    "uf-preds-0": -0.183,
    "uf-preds-1": -0.368,
    "uf-preds-2": -0.31,
    "uf-preds-3": -0.24,
    "uf-preds-4": -0.124,
    "uf-preds-5": 0.072,
    "uf-preds-6": 0.069,
    "uf-preds-7": -0.085,
    "uf-preds-8": -0.069,
    "uf-preds-9": -0.261,
    "uf-preds-10": -0.11,
    "uf-preds-11": 0.085,
    "uf-preds-12": -0.144,
    "uf-preds-13": 0.092,
    "uf-preds-14": -0.283,
    "of-preds-0": -0.064,
    "of-preds-1": -0.169,
    "of-preds-2": -0.056,
    "of-preds-3": -0.571,
    "of-preds-4": -0.709,
    "of-preds-5": 0.91,
    "of-preds-6": -0.81,
    "of-preds-7": -0.195,
    "of-preds-8": -0.162,
    "of-preds-9": -0.105,
    "of-preds-10": 0.045,
    "of-preds-11": -0.085,
    "of-preds-12": -0.081,
    "of-preds-13": -0.269,
    "of-preds-14": -0.55,
    "good-preds-0": -0.235,
    "good-preds-1": -0.207,
    "good-preds-2": -0.316,
    "good-preds-3": -0.355,
    "good-preds-4": -0.292,
    "good-preds-5": 0.306,
    "good-preds-6": 0.088,
    "good-preds-7": -0.23,
    "good-preds-8": 0.007,
    "good-preds-9": -0.155,
    "good-preds-10": -0.315,
    "good-preds-11": 0.089,
    "good-preds-12": -0.241,
    "good-preds-13": -0.134,
    "good-preds-14": -0.47,
  },
  {
    x: 0.94,
    "uf-preds-0": -0.289,
    "uf-preds-1": -0.542,
    "uf-preds-2": -0.414,
    "uf-preds-3": -0.359,
    "uf-preds-4": -0.2,
    "uf-preds-5": 0.052,
    "uf-preds-6": 0.038,
    "uf-preds-7": -0.098,
    "uf-preds-8": -0.11,
    "uf-preds-9": -0.327,
    "uf-preds-10": -0.177,
    "uf-preds-11": 0.048,
    "uf-preds-12": -0.243,
    "uf-preds-13": 0.098,
    "uf-preds-14": -0.435,
    "of-preds-0": -1.21,
    "of-preds-1": -0.515,
    "of-preds-2": 0.257,
    "of-preds-3": -2.259,
    "of-preds-4": 0.985,
    "of-preds-5": -0.114,
    "of-preds-6": 1.803,
    "of-preds-7": 0.984,
    "of-preds-8": -1.93,
    "of-preds-9": -1.027,
    "of-preds-10": 0.553,
    "of-preds-11": 0.753,
    "of-preds-12": 0.763,
    "of-preds-13": 0.295,
    "of-preds-14": 3.604,
    "good-preds-0": 0.22,
    "good-preds-1": -0.089,
    "good-preds-2": 0.743,
    "good-preds-3": 0.631,
    "good-preds-4": 0.351,
    "good-preds-5": 0.514,
    "good-preds-6": 0.664,
    "good-preds-7": 1.031,
    "good-preds-8": 0.881,
    "good-preds-9": 0.735,
    "good-preds-10": 0.903,
    "good-preds-11": 0.811,
    "good-preds-12": 0.883,
    "good-preds-13": 0.735,
    "good-preds-14": -0.142,
  },
];
